import { FC, ReactNode } from 'react'

import { Button, Props as ButtonProps } from '../button'

import s from './styles.module.scss'

interface Props extends Omit<ButtonProps, 'slot'> {
  slot?: ReactNode
}

export const ButtonContinue: FC<Props> = ({
  children,
  slot,
  ...buttonProps
}) => (
  <div className={s.emptyWrapper}>
    <div className={s.container}>
      {slot && <div className={s.slot}>{slot}</div>}
      <Button
        className="semi-bold-16"
        {...buttonProps}
      >
        {children}
      </Button>
    </div>
  </div>
)
